import dayjs from 'dayjs';
import { i18next } from '@frontend/i18n';

export const getActionTitleAndLink = () => {
  const now = new Date();
  const after30thJune = dayjs(now).diff(dayjs('2025-06-30').endOf('day')) > 0;

  if (after30thJune) {
    return {
      actionTitle: i18next.t('Contact Customer Support', { ns: 'syncAppAuth' }),
      link: 'https://www.weavehelp.com/weavehelp/contact-us',
    };
  } else {
    return {
      actionTitle: i18next.t('Complete Cornerstone Enrollment', { ns: 'syncAppAuth' }),
      link: 'https://www.weavehelp.com/weavehelp/article/self-install-your-cornerstone-integration?objectID=self-install-your-cornerstone-integration',
    };
  }
};

export const getMessageAndTitle = () => {
  let message = '';
  let title = '';

  const now = new Date();
  const nowTime = dayjs(now);

  const JUNE_13 = dayjs('2025-06-13').endOf('day');
  const JUNE_20 = dayjs('2025-06-20').endOf('day');
  const JUNE_30 = dayjs('2025-06-30').endOf('day');

  const before13thJune = nowTime.diff(JUNE_13) < 0;
  const between13thAnd20thJune = nowTime.diff(JUNE_13) > 0 && nowTime.diff(JUNE_20) < 0;
  const between20thAnd30thJune = nowTime.diff(JUNE_20) > 0 && nowTime.diff(JUNE_30) < 0;

  if (before13thJune) {
    message = i18next.t(
      "Cornerstone integration with Weave ends June 30th, 2025. Transition to our new integration now - we'll guide you thorough it.",
      { ns: 'syncAppAuth' }
    );
    title = i18next.t('Cornerstone Integration Update required', { ns: 'syncAppAuth' });
  } else if (between13thAnd20thJune) {
    message = i18next.t(
      "Your Cornerstone integration ends June 30th, 2025. Migrate now to avoid data sync disruptions. Easy transition with our help guide - dont't wait until the deadline.",
      { ns: 'syncAppAuth' }
    );

    title = i18next.t("Time's Running out! Complete your Cornerstone Integration Migration", {
      ns: 'syncAppAuth',
    });
  } else if (between20thAnd30thJune) {
    message = i18next.t(
      'Time is running out! Switch to the new Cornerstone integration by June 30 to avoid losing reminders, confirmations and sync.',
      { ns: 'syncAppAuth' }
    );

    title = i18next.t('Final Reminder: Switch to Cornerstone Sync by June 30', {
      ns: 'syncAppAuth',
    });
  } else {
    message = i18next.t(
      'To restore your reminders, confirmations and data sync, please contact our support team at [+1-888-579-5668] to complete the switch to the new integration.',
      { ns: 'syncAppAuth' }
    );

    title = i18next.t('Your Cornerstone Integration has Expired', { ns: 'syncAppAuth' });
  }

  return { message, title };
};
